import React from "react";
import { useFetchExtractedScreenshotsSuspense } from "../../../hooks/useFetchExtractedScreenshots";
import RlCloudSandboxCarousel from "./carousel/RlCloudSandboxCarousel";

type Props = {
  hash: string;
  activeAnalysisId: string;
  isNetwork: boolean;
};

const RlCloudSandboxCarouselWrapper: React.FC<Props> = ({
  hash,
  activeAnalysisId,
  isNetwork = false
}) => {
  const { imagePaths, imageGroups } = useFetchExtractedScreenshotsSuspense(
    hash,
    activeAnalysisId,
    isNetwork
  );

  return (
    <RlCloudSandboxCarousel imagePaths={imagePaths} imageGroups={imageGroups} />
  );
};

export default RlCloudSandboxCarouselWrapper;
